import { useDispatch, useSelector } from "react-redux";
import { useForm } from 'react-hook-form';
import { COMPANY, PROJECT, PROJECTALL, USER } from "../../services/actions";
import { useNavigate } from "react-router-dom";
import React from "react";
import { Button, Container, Box, Grid, Tab, Tabs, Pagination } from "@mui/material";
import InfoCard from "../extra/InfoCard";
import { BsFilePlusFill } from "react-icons/bs";
import RDialog from "../extra/RDialog";
import Form from './Form';
import ActionBar from "../extra/ActionBar";
import ProjectImg from './project.jpg'
import SearchBar from "../extra/SearchBar";
import InfoCard2 from "../extra/InfoCard2";
import { isBase64Image } from "../../libs/Libs";
import XTable from "../extra/XTableAnother";
import MoreInfo from "../extra/MoreInfo";
import { BsCopy } from "react-icons/bs";

export default function View() {
  let dispatch = useDispatch()
  const [open, setOpen] = React.useState(false)
  const [defV, setDefV] = React.useState({})
  const [view, setView] = React.useState(1);
  const navigate = useNavigate();
  let ref = React.createRef()
  let ref2 = React.createRef()
  let projectState = useSelector((state) => state?.projectState)
  let projectallState = useSelector((state) => state?.projectallState)
  let companyState = useSelector((state) => state?.companyState)
  const [companies, setCompanies] = React.useState([])
  let user = useSelector((state) => state?.loginState?.auth)
  const [page, setPage] = React.useState(0); // current page  
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchProjects = (page = 0) => {
    const url = page === 0 ? `project/${page}/` : `project/?page=${page}`;// pass page number    
    dispatch({ type: `${PROJECTALL}_GET`, payload: url });
  }

  React.useEffect(() => {
    try {
      fetchProjects(0);
      dispatch({ type: `${COMPANY}_GET`, payload: 0 })
    } catch (err) {
    }
  }, [])

  React.useEffect(() => {
    fetchProjects(page);
  }, [page]);

  React.useEffect(() => {
    setCompanies(companyState?.data?.results)
  }, [companyState?.data])
  React.useEffect(() => {
    if (projectState?.success) {
      setOpen(!projectState?.success)
      dispatch({ type: `${PROJECTALL}_GET`, payload: 0 })
    }

  }, [projectState?.data])

  // Handle filter search
  const handleSearch = (key, value) => {
    const query = `project/0/?filter_by={"${key}__istartswith":"${value}"}`;
    dispatch({ type: `${PROJECTALL}_GET`, payload: query });
  };
  const tableHeadings = ["ID", "image", "Project Name", "Company Name", "Country", "Duration", "Camera Count"];
  const tableRows = projectallState?.data?.results?.map((project) => ({
    id: project.id,
    image: project.project_image,
    project_name: project.project_name,
    company_name: project.company_name,
    country: project.country,
    duration: project.duration,
    camera_count: project.camera_count,


  }));

  const handleDelete = (id) => {
    dispatch({ type: `${PROJECT}_DELETE`, payload: id });
  };

  return (
    <>

      {open ? <Form companies={companies}
        defaultValues={defV}

        onSubmit={(data) => {
          console.log("DATA", data)
          if (!isBase64Image(data.image)) {
            delete data["image"]
          }

          let action = data.id ? `${PROJECT}_PATCH` : `${PROJECT}_POST`
          dispatch({ type: action, payload: data })
        }}
        back={() => { setOpen(false) }}
      />
        : <Container maxWidth="false" className="py-3">
          <ActionBar
            showGrid={[2, 5]}
            onBtnClick={(type, col) => {
              if (type === "grid") {
                setView(1);
              }
              if (type === "tabular") {
                setView(2);
              }
            }}
            hasPermission={user.permissions.includes('project.add_project')}
            label="Project" setOpen={(s) => {
              if (user.main_role == "Company") {
                setCompanies(user?.companies)
              } else {
                dispatch({ type: `${COMPANY}_GET`, payload: 0 })
              }
              setDefV({});
              setOpen(true);

            }}
            btnLabel="ADD PROJECT" />
          <SearchBar bylist={[
            { key: "project_name", label: "Project name" },
            { key: "company__company_name", label: "Company name" },
          ]} handleSearch={handleSearch} />
          {view === 1 && (
            <>
              <Grid container spacing={1}>
                {projectallState?.data?.results.map((data) => {
                  if (!data.image) {
                    data.image = ProjectImg

                  }
                  data.verify_display = data.verify ? "Yes" : "No";
                  data.no_users = data?.users?.length
                  return <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }}>
                    <InfoCard2
                      keys={[
                        "image",
                        "project_name",
                        "company_name",
                        "country_name",
                        "Duration",
                        "duration",
                        "Verified",
                        "verify_display",
                        "Camera",
                        "camera_count"
                      ]}
                      data={data}

                      onClick={() => {

                        //navigate("/timelapse-preview/", {})
                      }}
                      onAction={(action, data) => {
                        if (action == "Edit") {

                          if (data.start_project_date) {
                            data.start_project_date = data.start_project_date.split("T")[0];
                          }
                          if (data.location) {
                            data.location = {
                              display_name: data.location.split("$")[0],
                              lat: data.location.split("$")[1]?.split(",")[0],
                              lon: data.location.split("$")[1]?.split(",")[1],
                            }
                          }
                          setDefV(data);
                          setOpen(true);
                        } else if (action == "Delete") {
                          dispatch({ type: `${PROJECT}_DELETE`, payload: data?.id })
                        }
                        else if (action == "More") {
                          setDefV(data);
                          setView(4)
                        }
                      }
                      }
                    />
                  </Grid>
                })}
              </Grid>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Pagination
                  count={Math.ceil(projectallState?.data?.count / pageSize)}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  color="primary"
                />
              </Box>
            </>
          )}
          {view === 2 && (
            <XTable
              head={tableHeadings}
              rows={tableRows}
              onEdit={(row) => {
                // Find the original project data from the full results
                const originalData = projectallState?.data?.results.find(
                  (project) => project.id === row.id
                );

                // Set the form's default values and open the form
                if (originalData) {
                  setDefV(originalData);
                  setOpen(true);
                }
              }}
              onDelete={handleDelete}
            />
          )}
          {view === 4 && <MoreInfo
            data={{
              ...defV,
              active: defV.active ? "Yes" : "No",
              verify: defV.verify ? "Yes" : "No",
            }}

            skip={['country', 'description', 'error_email', 'no_users', 'owner', 'image']}
            group={['', 'project_name', 'created_at',]}
            icons={{ project_image: <BsCopy /> }}
            css={{ project_image: { color: '#1976d2' } }}
            onClose={() => { setView(1) }} />}

        </Container>}

    </>
  )
}